module.exports = __webpack_public_path__ + "img/QLayout.b9dc9da6.svg";